import { Alert, Snackbar } from "@mui/material"
import React, { useEffect } from "react"
import { useAppDispatch, useAppSelector } from "../util/hooks"
import { IAlertStatus } from "../util/interface"
import { setAlertData2 } from "../features/Monitor/MonitorSlice"

export default function CustomSnackBar() {
  const [open, setOpen] = React.useState(true)
  const alertData: IAlertStatus = useAppSelector(
    (state) => state.monitor.alertStatus,
  )
  const dispatch = useAppDispatch()
  const handleClose = (
    event: React.SyntheticEvent | Event,
    reason?: string,
  ) => {
    if (reason === "clickaway") {
      return
    }
    setOpen(false)
    dispatch(
      setAlertData2({
        msg: "",
        status: "info",
        open: false,
      }),
    )
  }

  useEffect(() => {
    setOpen(alertData.open)
  }, [alertData])

  return alertData.open ? (
    <Snackbar
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      open={open}
      onClose={handleClose}
      autoHideDuration={5000}
    >
      <Alert
        onClose={handleClose}
        severity={alertData.status}
        // severity={'error'}
        variant="filled"
        sx={{ width: "100%" }}
      >
        {alertData.msg}
      </Alert>
    </Snackbar>
  ) : (
    ""
  )
}
